import React, { useEffect, useState } from 'react';
import { Button, Stack, TextField, Typography, useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { FormControl, RadioGroup, FormControlLabel, Radio, Select, MenuItem } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { baseUrl } from '../lib/const';

// const questions = [
//     { id: 0, text: "Selezionare efficienza di base:", options: ['Rotolone con irrigatore a cannone o barra nebulizzatrice, senza centralina elettronica di controllo della velocità e della pluviometria ', "Rotolone con irrigatore cannone dotato di manometro sulla macchina e sull'irrigatore, centralina elettronica di controllo della velocità e della pluviometria", "Rotolone con barra nebulizzatrice a bassa pressione (<3,5 atmosfere) dotato di manometro sulla macchina e sull'irrigatore, centralina elettronica di controllo della velocità e della pluviometria"], type: 'select' },
//     { id: 1, text: "E' presente un sistema di misura e conteggio dei volumi prelevati:", options: ['Sì', 'No'], type: 'radio' },
//     { id: 2, text: 'Vi è la possibilità di inserire i mm di irrigazione?', options: ['Sì', 'No'], type: 'radio' },
//     { id: 3, text: 'Possibilità di irrigare a settori:', options: ['Sì', 'No'], type: 'radio' },
//     { id: 4, text: 'Irrigatore con la possibilità di variare la velocità di rotazione?', options: ['Sì', 'No'], type: 'radio' },
//     { id: 5, text: "Elementi che migiorano l'efficacia degli interventi irrigui:", options: ['No', 'Gestione vento', 'Gestione radiazione', 'Gestione pioggia', 'Gestione pressione', 'Gestione portata', 'Due o più dei suddetti'], type: 'select' },
//     { id: 6, text: 'La macchina è interfacciata con tecnologia 4.0 (interfacciamento da remoto per acquisizione/invio dati irrigazione)?', options: ['Sì', 'No'], type: 'radio' },
//     { id: 7, text: 'Stazione Agrometeorologica per la stima dei fabbisogni idrici:', options: ['Sì', 'No'], type: 'radio' },
//     { id: 8, text: 'Presenza Pluviometro aziendale:', options: ['Sì, con lettura manuale', 'Sì, con invio dati IoT', 'No'], type: 'radio' },
//     { id: 9, text: "Funzionalità che migliorano la pratica degli interventi irrigui generando blocchi dell'irrigazione / allarmi / notifiche:", options: ['No', 'Sospensione per assenza pressione', 'Arresto avaria', 'Durata massima programmabile', 'Gestione getto ausiliario', 'Programmi di irrigazione', 'Arresto a distanza e/o ora programmabili', 'Partenza ritardata', 'Due o più delle precedenti', 'Altro riferibile alle categorie suddette'], type: 'select' },
//     { id: 10, text: 'DSS IRRIGUO:', options: ['Sì', 'No'], type: 'radio' },
//     { id: 11, text: 'Sensoristica di umidità del suolo:', options: ['Sì', 'No'], type: 'radio' },
//     { id: 12, text: 'Azienda che effettua la fertirrigazione:', options: ['Sì', 'No'], type: 'radio' },
//     { id: 13, text: "Presenza di accorgimenti che migliorano l'utilizzo dell'energia:", options: ['No', 'Recupero a motore', 'Motopompa incorporata', 'Autospegnimento', 'Pannello solare', 'Due o più delle precedenti', 'Altro riferibile alle categorie suddette'], type: 'select' },// Add more questions as needed
// ];

const Rotoloni = () => {
    const [answers, setAnswers] = useState({});
    const navigate = useNavigate();
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'))
    const [questions, setQuestions] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`${baseUrl}domande?page=rotoloni`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const data = await response.json();
                setQuestions(data);
            } catch (error) {
                console.error('Error fetching data:', error.message);
            }
        };

        fetchData();
    }, [])

    const formStyle = {
        maxWidth: isSmallScreen ? '90vw' : '',
        width: isSmallScreen ? '' : '50vw',
    };

    const handleAnswerChange = (questionId, answer) => {
        setAnswers((prevAnswers) => ({ ...prevAnswers, [questionId]: answer }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Assuming answers is a state variable, use setAnswers to update the state
        const response = await fetch(`${baseUrl}rotoloni/efficienza`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ answers })
        })

        let efficiency;

        if(response.ok) {
            const data = await response.json()
            efficiency = data.totalEfficiency
        }

        navigate('/risultati', { state: { answers: answers, page: 'Rotoloni', questions, efficiency: Math.round(efficiency) } })
    };

    const isFormValid = () => {
        // Check if there is a valid answer for each question
        return questions.every((question) => {
            const answer = answers[question.id];
            switch (question.type) {
                case 'radio':
                    return answer !== undefined && answer !== '';
                case 'select':
                    return answer !== undefined && answer !== '';
                case 'text':
                    return answer !== undefined && answer.trim() !== '';
                default:
                    return false;
            }
        });
    };

    const renderQuestionType = (question) => {
        switch (question.type) {
            case 'radio':
                return (
                    <RadioGroup
                        sx={{ width: "50%", paddingLeft: "15px" }}
                        value={answers[question.id] || ''}
                        onChange={(e) => handleAnswerChange(question.id, e.target.value)}
                    >
                        {question.options.map((option, index) => (
                            <FormControlLabel
                                key={index}
                                value={option}
                                control={<Radio />}
                                label={option}
                            />
                        ))}
                    </RadioGroup>
                );
            case 'select':
                return (
                    <div style={{ width: "50%", maxWidth: "50%", paddingLeft: "15px" }}>
                        <Select
                            sx={{ width: "100%" }}
                            value={answers[question.id] || ''}
                            onChange={(e) => handleAnswerChange(question.id, e.target.value)}
                        >
                            {question.options.map((option, index) => (
                                <MenuItem key={index} value={option} sx={{ whiteSpace: 'normal' }}>
                                    {option}
                                </MenuItem>
                            ))}
                        </Select>
                    </div>
                );
            case 'text':
                return (
                    <TextField
                        sx={{ width: "50%", paddingLeft: "15px" }}
                        value={answers[question.id] || ''}
                        onChange={(e) => {
                            const numericValue = e.target.value.replace(/[^0-9,.]/g, '');
                            handleAnswerChange(question.id, numericValue)
                        }}
                        id="outlined-basic"
                        variant="outlined"
                        inputProps={{ pattern: "[0-9,.]*" }} />
                );
            // Add more cases as needed for other question types
            default:
                return null; // or handle unknown question types
        }
    };

    return (
        <div style={{ display: "flex", justifyContent: "center", marginTop: "40px" }}>
            <form onSubmit={handleSubmit} style={formStyle}>
                <Stack direction="column">
                    <Typography variant="h1" color='primary' sx={{ fontSize: '28px', fontWeight: 'bold', marginBottom: "20px" }}>Inserire dati rotoloni</Typography>
                    {questions.map((question) => (
                        <FormControl key={question.id} component="fieldset" sx={{ marginY: "10px" }}>
                            <Stack direction="row">
                                <legend style={{ width: "50%", fontWeight: question.id === 0 ? 'bold' : '', textAlign: "right" }}>{question.text}</legend>
                                {renderQuestionType(question)}
                            </Stack>
                        </FormControl>
                    ))}
                    <div>
                        <Button disabled={!isFormValid()} sx={{ marginY: "40px", width: "200px", justifyContent: "center" }} type="submit" variant="contained" color="primary">
                            CALCOLA EFFICIENZA
                        </Button>
                    </div>
                </Stack>
            </form>
        </div>
    );
};

export default Rotoloni;
